<!-- <app-header-one ></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="terms-popup">
    <div class="popup-container">
        <div class="popup-card">
            <!-- <h2 class="title" >{{tncData.title}}</h2>
            <div [innerHTML]="tncData.description"></div> -->
          </div>
         <div class="popup-card">
            <h2 class="title" style="cursor: pointer;">Privacy & Policy</h2>
            <p>Welcome to www.neohrmz.com</p>
            <p>NeoHRMZ <strong>(“NeoHRMZ”, “we”, “our”, “us”)</strong> is  the HRMS portal of
                JoJo Techland Pvt. Ltd., [JTPL]. NeoHRMZ operates through www.neohrmz.com website (“Services”).</p>
            <p>Our Privacy Policy governs your visit to www.neohrmz.com website and explains how we collect,
                 safeguard and disclose information that results from your use of our services.  </p>
            <p>NeoHRMZ uses your data to provide and improve our services from
                 time to time. By using our services, you agree to the collection and use of information in
                  accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms
                   used in this Privacy Policy have the same meanings as in our Terms and Conditions.
                Our Terms and Conditions<strong>(“Terms”, “Terms of Use”, “Terms of Service”, “Service Terms”)</strong>
                govern all use of NeoHRMZ’s Services, and together with the Privacy Policy constitutes your agreement
                with us<strong> (“Agreement”)</strong>.
            </p>
            <h2>DEFINITIONS</h2>
            <p><strong>SERVICES</strong> mean the www.neohrmz.com website deals with the
                 comprehensive HRMS related application of JoJo Techland Pvt. Ltd.</p>
            <p> <strong>DATA [Personal or Corporate Data]</strong> means data about a living individual or a firm who/which is either 
                registered with us, or is our subscriber, or the one that uses our Services, at least once or 
                often, or other information either in our possession or likely to come into our possession.</p>
            <p>USAGE DATA is data collected automatically either generated by the use of our services or from services 
                infrastructure itself (e.g. the duration of a page visit).</p>
            <p>COOKIES mean small electronic files stored on your device (computer, tablets or mobile devices) 
                which help in enhancing the users’ experiences.</p>
            <p><strong>DATA CONTROLLER</strong> means a natural or legal person who (either alone or jointly or in common with other persons)
                 determines the purposes for which and the manner in which any personal or corporate data are, or are to be
                 , processed. For the purpose of this Privacy Policy, we are a Data Controller of your data.</p>
            <p><strong>DATA PROCESSORS (OR SERVICE PROVIDERS)</strong>) mean any person or entity which processes
                 the data on behalf of the Data Controller. We may use the services of various Service Providers 
                 in order to process your data more effectively.</p>
            <p><strong>DATA SUBJECT</strong> is any living individual or corporate who/which is the subject of Personal Data.
                <strong>THE USER</strong> is the individual using our Services. The User corresponds to the Data Subject, who is the
                subject of Personal Data.
            </p>

            <h2>Information Collection and Use</h2>
            <p>NeoHRMZ collects several different types of information for various purposes to provide and improve our
                 services from time to time for you.</p>
            <h2>Types of Data Collected :</h2>
            <h2>Personal Data</h2>
            <p>While using our NeoHRMZ’s Services, we may ask you to provide us with certain personally identifiable
                information that can be used to contact or identify you <strong>(“Personal Data”)</strong>. Personally identifiable
                information may include, but is not limited to:</p>
            <ul>
                <li>Email address</li>
                <li>First name and last name</li>
                <li>Phone number</li>
                <li>Address, State, Province, ZIP/Postal code, City</li>
                <li>Cookies and Usage Data</li>
            </ul>
            <p>We may use your Personal Data to contact you with newsletters, marketing or promotional materials and
                other information that may be of interest to you. You may opt out of receiving any, or all, of these
                communications from us by following the unsubscribe link, by emailing at <a
                    href="mailto:support&#64;neohrmz.com">support&#64;neohrmz.com</a>
            </p>
            <h2>Usage Data</h2>
            <p>NeoHRMZ may also collect information that your browser sends whenever you visit NeoHRMZ’s 
                services, or when you access our services by or through a mobile device <strong>(“Usage Data”)</strong>.</p>
            <p>This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address),
                 browser type, browser version, the pages of our Services that you visit, the time and date of your visit,
                  the time spent on those pages, unique device identifiers and other diagnostic data..</p>
            <p>When you access our Services with a mobile device, this Usage Data may include information such as the type
                 of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile
                 operating system, the type of mobile Internet browser you use, unique device identifiers, and other diagnostic data.</p>

            <h2>Location Data</h2>
            <p>NeoHRMZ may use and store information about your location as given by you <strong>(“Location Data”)</strong>. We use this 
            data to provide features of our services, to improve and customize our services.</p>
            <p>You can enable or disable location services when you use our Services at any time by way of your device
                settings.</p>

            <h2>Tracking Cookies Data</h2>
            <p>NeoHRMZ uses cookies and similar tracking technologies to track the activity on our Services and we
                hold certain information.
                Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies
                are sent to user’s browser from a website and are stored on user’s device. Other tracking technologies
                are also used such as beacons, tags and scripts to collect and track information and to improve and
                analyze our Service.
                You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However,
                if you do not accept cookies, you may not be able to use some or all portions of our Services.
            </p>
            <p>Examples of Cookies we use :</p>
            <ul>
                <li>
                    <p><strong>1. Session Cookies: </strong>We use Session Cookies to operate our Services.</p>
                    <p><strong>2. Preference Cookies: </strong>: We use Preference Cookies to remember your preferences
                        and various settings.</p>
                    <p><strong>3. Security Cookies: </strong>We use Security Cookies for security purposes.</p>
                    <p><strong>4. Advertising Cookies: </strong>Advertising Cookies are used to serve you with adverts
                        that may be relevant to you and your interests</p>
                </li>
            </ul>

            
            <h2>Other Data</h2>
            <p>While using NeoHRMZ’s Services, we may also collect the following information: sex, age, date of birth,
                place of birth, passport details, citizenship, registration at place of residence and actual address,
                telephone numbers <strong>(work, mobile)</strong>, details of documents on education, qualification,
                professional training, employment agreements, non-disclosure agreements, compensation and other sources
                of income, information on marital status, family members, social security <strong>(or other taxpayer
                    identification)</strong> number, office location, and other data.</p>
            <h2>Use of Data</h2>
            <p>NeoHRMZ uses the collected data for various purposes :</p>
            <ul>
                <li>
                    <p>1. to provide and maintain our Service;</p>
                </li><br>
                <li>
                    <P>2. to notify you about changes to our Service; </P>
                </li><br>
                <li>
                    <p>3. to allow you to participate in interactive features of our Service when you choose to do so;
                    </p>
                </li><br>
                <li>
                    <p>4. to provide customer support;</p>
                </li><br>
                <li>
                    <p>5. to gather analysis or valuable information so that we can improve our Service;</p>
                </li><br>
                <li>
                    <p>6. to monitor the usage of our Service;</p>
                </li><br>
                <li>
                    <p>7. to detect, prevent and address technical issues;</p>
                </li><br>
                <li>
                    <p>8. to fulfill any other purpose for which you provide it;</p>
                </li><br>
                <li>
                    <p>9. to carry out our obligations and enforce our rights arising from any contracts entered into
                        between you and us, including for billing and collection;</p>
                </li><br>
                <li>
                    <p>10. to provide you with notices about your account and/or subscription, including expiration and
                        renewal notices, email-instructions, etc.;</p>
                </li><br>
                <li>
                    <p>11. to provide you with news, special offers and general information about other goods, services
                        and events which we offer that are similar to those that you have already purchased or enquired
                        about unless you have opted not to receive such information;
                </li>
                <li>
                    <p>12. in any other way we may describe when you provide the information;</p>
                </li><br>
                <li>
                    <p>13. for any other purpose with your consent.</p>
                </li><br>
            </ul>

            <h2>Retention of Data</h2>
            <p>NeoHRMZ retains users’ Personal Data only for as long as is necessary for the purposes set out in this
                Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our
                legal obligations <strong>(for example, if we are required to retain your data to comply with applicable
                    laws)</strong>, resolve disputes, and enforce our legal agreements and policies.
                We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a
                shorter period, except when this data is used to strengthen the security or to improve the functionality
                of our Service, or we are legally obligated to retain this data for longer time periods.
            </p>
            <h2>Transfer of Data</h2>
            <p>Your information, including Personal Data, may be transferred to, and maintained on, computers located
                outside of your state, province, country or other governmental jurisdiction where the data protection
                laws may differ from those of your jurisdiction.</p>
            <p>If you are located outside India and choose to provide information to us, please note that we transfer
                the data, including Personal Data, to India and process it there.</p>
            <p>Your consent to this Privacy Policy followed by your submission of such information represents your
                agreement to that transfer.</p>
            <p>NeoHRMZ takes all the steps reasonably necessary to ensure that your data is treated securely and in
                accordance with this Privacy Policy and no transfer of your Personal Data will take place to an
                organization or a country unless there are adequate controls in place including the security of your
                data and other personal information.</p>


            <h2>Disclosure of Data</h2>
            <p>NeoHRMZ may disclose personal information that we collect, or you provide to the law enforcers or the
                government of India when requested.</p>
            <ul>
                <li><strong>1. Disclosure for Law Enforcement.</strong>
                    <p>Under certain circumstances, we may be required to disclose your Personal Data if required to do
                        so by law or in response to valid requests by public authorities.</p>
                </li>
                <li><strong>2. Business Transaction.</strong>
                    <p>If we or our subsidiaries are involved in a merger, acquisition or asset sale, your Personal Data
                        may be transferred.</p>
                </li>
                <li><strong>3. Other cases. We may disclose your information also:</strong>
                    <p> 1. to our subsidiaries and affiliates;</p>
                    <p> 2. to contractors, service providers, and other third parties we use to support our business;
                    </p>
                    <p> 3. to fulfill the purpose for which you provide it;</p>
                    <p> 4. for the purpose of including your company’s logo on our website;</p>
                    <p> 5. for any other purpose disclosed by us when you provide the information;</p>
                    <p> 6. with your consent in any other cases;</p>
                    <p> 7. if we believe disclosure is necessary or appropriate to protect the rights, property, or
                        safety of the Company, our customers, or others.</p>

                </li>
            </ul>


            <h2>Security of Data</h2>
            <p>The security of your data is important to us but remember that no method of transmission over the
                Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable
                means to protect your Personal Data, we cannot guarantee its absolute security.</p>

            <h2>Data Protection Rights</h2>
            <p>NeoHRMZ takes necessary steps to protect your data from being used for unwanted purposes.
                NeoHRMZ aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of your
                Personal Data.
            </p>

            <p>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our
                systems, please email us at <a href="mailto:support&#64;neohrmz.com">support&#64;neohrmz.com</a></p>
            <p>In certain circumstances, you have the following data protection rights:</p>
            <ul>
                <li>
                    <p> 1. the right to access, update or to delete the information we have on you;</p>
                </li>
                <li>
                    <p> 2. the right of rectification. You have the right to have your information rectified if that
                        information is inaccurate or incomplete;</p>
                </li>
                <li>
                    <p> 3. the right to object. You have the right to object to our processing of your Personal Data;
                    </p>
                </li>
                <li>
                    <p> 4. the right of restriction. You have the right to request that we restrict the processing of
                        your personal information;</p>
                </li>
                <li>
                    <p> 5. the right to data portability. You have the right to be provided with a copy of your Personal
                        Data in a structured, machine-readable and commonly used format;</p>
                </li>
                <li>
                    <p> 6. the right to withdraw consent. You also have the right to withdraw your consent at any time
                        where we rely on your consent to process your personal information;</p>
                </li>
            </ul>

            <p>Please note that we may ask you to verify your identity before responding to such requests. Please note,
                we may not able to provide our Services without some necessary data.
                You have the right to complain to a Data Protection Authority about our collection and use of your
                Personal Data. For more information, please contact your local data protection authority India.
            </p>

            <h2>Service Providers</h2>
            <p>NeoHRMZ may employ third party companies and individuals to facilitate our Services <strong>(“Service
                    Providers”)</strong>, provide Service on our behalf, perform Service-related services or assist us
                in analysing how our Services are used.</p>
            <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are
                obligated not to disclose or use it for any other purpose.</p>

            <h2>Analytics</h2>
            <p>NeoHRMZ may use third-party Service Providers to monitor and analyze the use of our Services.</p>

            <h2>Google Analytics</h2>
            <p>Google Analytics is a web analytics service offered by Google that tracks and reports website traffic.
                Google uses the data collected to track and monitor the use of NeoHRMZ’s Services. This data is shared
                with other Google services. Google may use the collected data to contextualise and personalise the ads
                of its own advertising network.</p>
            <p>For more information on the privacy practices of Google, please visit the Google Privacy Terms.
                We also encourage you to review the Google's policy for safeguarding your data.
            </p>

            <h2>Advertising</h2>
            <p>NeoHRMZ may use third-party Service Providers to show advertisements to you to help support and
                maintain our Service.</p>
            <h2>Google AdSense DoubleClick Cookie</h2>
            <p>Google, as a third party vendor, uses cookies to serve ads on our Service. Google's use of the
                DoubleClick cookie enables it and its partners to serve ads to our users based on their visit to our
                Service or other websites on the Internet.
                You may opt out of the use of the DoubleClick Cookie for interest-based advertising by visiting the
                Google Ads Settings web page
            </p>

            <h2>Bing Ads</h2>
            <ul>
                <li>
                    <p>Bing Ads is an advertising service provided by Microsoft Inc.</p>
                </li><br>
                <li>
                    <p>You can opt-out from Bing Ads by following the instructions on Bing Ads Opt-out page.</p>
                </li><br>
                <li>
                    <p>For more information about Bing Ads, please visit their Privacy Policy.</p>
                </li><br>
            </ul>


            <h2>AdMob by Google</h2>
            <p>AdMob by Google is provided by Google Inc.<br>
                You can opt-out from the AdMob by Google service by following the instructions described by Google.
            </p>
            <p>For more information on how Google uses the collected information, please visit the “How Google uses data
                when you use our partners' sites or app” page.</p>

            <h2>AdButler</h2>
            <p>AdButler is an advertising service provided by Sparklit Networks Inc.<br>
                For more information about AdButler, please visit their Privacy Policy
            </p>

            <h2>Unity Ads</h2>
            <p>Unity Ads is provided by Unity Technologies.<br>
                You can opt-out from Unity Ads service by following the instructions as described by Unity Technologies
                on their Privacy Policy page.<br>
                For more information about Unity Technologies, please visit Unity Technologies Privacy Policy.
            </p>

            <h2>Behavioral Remarketing</h2>
            <p>NeoHRMZ uses remarketing services to advertise on third party websites to you after you visited our
                Service. We and our third-party vendors use cookies to inform, optimise and serve ads based on your past
                visits to our Service.</p>

            <p><strong>Google Ads (AdWords)</strong>
                Google Ads<strong> (AdWords) </strong>remarketing service is provided by Google Inc.
                You can opt-out of Google Analytics for Display Advertising and customize the Google Display Network ads
                by visiting the Google Ads Settings page.
                Google also recommends installing the Google Analytics Opt-out Browser Add-on for your web browser.
                Google Analytics Opt-out Browser Add-on provides visitors with the ability to prevent their data from
                being collected and used by Google Analytics.
                For more information on the privacy practices of Google, please visit the Google Privacy Terms web page.
            </p>

            <p><strong>Bing Ads Remarketing</strong>
                Bing Ads remarketing service is provided by Microsoft Inc.
                You can opt-out of Bing Ads interest-based ads by following their instructions.
                You can learn more about the privacy practices and policies of Microsoft by visiting their Privacy
                Policy page.
            </p>

            <p><strong>Twitter</strong>
                Twitter remarketing service is provided by Twitter Inc.
                You can opt-out from Twitter's interest-based ads by following their instructions.
                You can learn more about the privacy practices and policies of Twitter by visiting their Privacy Policy
                page.
            </p>

            <p><strong>Facebook</strong>
                Facebook remarketing service is provided by Facebook Inc.
                You can learn more about interest-based advertising from Facebook by visiting this page.
                To opt-out from Facebook's interest-based ads, follow these instructions from Facebook.
                Facebook adheres to the Self-Regulatory Principles for Online Behavioural Advertising established by the
                Digital Advertising Alliance. You can also opt-out from Facebook and other participating companies
                through the Digital Advertising Alliance, or opt-out using your mobile device settings.
                For more information on the privacy practices of Facebook, please visit Facebook's Data Policy.

            </p>

            <h2>Payments</h2>
            <p>NeoHRMZ may provide paid products and/or services within its Services. In that case, we use third-party
                services for payment processing (e.g. payment processors).
                We will not store or collect your payment card details. That information is provided directly to our
                third-party payment processors whose use of your personal information is governed by their Privacy
                Policy. These payment processors adhere to the standards set by PCI-DSS as managed by the PCI Security
                Standards Council, which is a joint effort of brands like Visa, Mastercard, American Express and
                Discover. PCI-DSS requirements help ensure the secure handling of payment information.
            </p>

            <h2>Links to Other Sites</h2>
            <p>NeoHRMZ Services may contain links to other sites that are not operated by us. If you click a third
                party link, you will be directed to that third party's site. We strongly advise you to review the
                Privacy Policy of every site you visit.
                We have no control over and assume no responsibility for the content, privacy policies or practices of
                any third party sites or services.
            </p>

            <h2>Children's Privacy</h2>
            <p>NeoHRMZ Services are not intended for use by children under the age of 18
                <strong>(“Children”)</strong>.
                We do not knowingly collect personally identifiable information from Children under 18. If you become
                aware that a Child has provided us with Personal Data, please contact us. If we become aware that we
                have collected Personal Data from Children without verification of parental consent, we take steps to
                remove that information from our servers.
            </p>

            <h2>Changes to This Privacy Policy</h2>
            <p>NeoHRMZ may update its Privacy Policy from time to time. We will notify you of any changes by posting
                the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any
                changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

            <h2>Contact Us</h2>

            <P style="text-align: center;">If you have any questions about this Privacy Policy, please contact us:<br>
                By email: <a href="mailto:support&#64;neohrmz.com">support&#64;neohrmz.com</a><br>
                By visiting this page on our website: www.neohrmz.com<br>
                By phone number: +91-984 984 8195<br>
                <!-- Address: India, Canada, UK -->
            </P>
        </div> 
    </div>
</section>
<!-- <app-footer-one></app-footer-one> -->

  <!-- <app-footer-more-info></app-footer-more-info> -->
    <app-peopleflow-footer></app-peopleflow-footer>
  